var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { SurveyNavigationBase } from "./reactSurveyNavigationBase";
import { ReactElementFactory } from "./element-factory";
import { List } from "./components/list/list";
import { Popup } from "./components/popup/popup";
import { SvgIcon } from "./components/svg-icon/svg-icon";
var SurveyProgressToc = /** @class */ (function (_super) {
    __extends(SurveyProgressToc, _super);
    function SurveyProgressToc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyProgressToc.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        var tocModel = this.props.model;
        tocModel.updateStickyTOCSize(this.survey.rootElement);
    };
    SurveyProgressToc.prototype.render = function () {
        var tocModel = this.props.model;
        var content;
        if (tocModel.isMobile) {
            content = React.createElement("div", { onClick: tocModel.togglePopup },
                React.createElement(SvgIcon, { iconName: tocModel.icon, size: 24 }),
                React.createElement(Popup, { model: tocModel.popupModel }));
        }
        else {
            content = React.createElement(List, { model: tocModel.listModel });
        }
        return (React.createElement("div", { className: tocModel.containerCss }, content));
    };
    return SurveyProgressToc;
}(SurveyNavigationBase));
export { SurveyProgressToc };
ReactElementFactory.Instance.registerElement("sv-navigation-toc", function (props) {
    return React.createElement(SurveyProgressToc, props);
});
